import { ParsedUrlQuery } from 'querystring'
import * as R from 'ramda'

export const extractArray = (query: ParsedUrlQuery, key: string) => {
  const value = R.propOr(undefined, key, query)

  return R.isNil(value) ? undefined : R.flatten([value] as any[])
}

export const extractValue = <T>(query: ParsedUrlQuery, key: string) => {
  const value = R.propOr(undefined, key, query)

  return value as T
}
